export const kurse = [
  {
    uebertitel: "",
    titel: "Morgenmalen",
    lead: ``,
    beschreibung: `
        <p>Ein grosses Blatt. Farben. Frische Blumen auf dem Tisch. Und ein Morgen, der dir gehört.</p>

        <p>Strich für Strich entsteht ein gemeinsames Bild. Ohne Vorlage und ohne festes Ziel. Du darfst Neues ausprobieren, beobachten oder einfach schauen, was sich zeigt.</p>

        <p>Das Ganze entsteht mit der Zeit.</p>

        <p>Mit frischem Kaffee, Tee und Gipfeln. In kleiner Gruppe, in entspannter Atmosphäre.</p>
    `,
    sidebar: `
        <p>
            <strong>Kursdatum & Ort</strong><br />
            MO, 17. August 2026 | 9.30 Uhr bis 11.30 Uhr <br />
            DI, 15. September 2026 | 9.30 Uhr bis 11.30 Uhr
        </p>
        <p>
            8 Personen | 2 Stunden Fr. 75.— <br />
            Appenzell am Bahnhof
        </p>`,
    image: "/assets/images/9726EAF5.jpg",
  },
  {
    uebertitel: "",
    titel: "Nachmittagsmalen",
    lead: ``,
    beschreibung: `
        <p>Ein grosses Blatt. Farben. Frische Blumen auf dem Tisch. Und ein freier Nachmittag.</p>

        <p>Wann hast du zuletzt einfach etwas ausprobiert? Beim Nachmittagsmalen darf gemalt, gekritzelt und ausprobiert werden.  Alle arbeiten an einem einzigen Bild. Jede:r bringt sich ein, wie es sich im Moment ergibt.</p>

        <p>Einfach die pure Freude am gemeinsamen Tun.</p>

        <p>Mit Kaffee, Tee und selbstgebackenem Kuchen.</p>
    `,
    sidebar: `
        <p>
            <strong>Kursdatum & Ort</strong><br />
            MO, 17. August 2026 | 13.30 Uhr bis 15.30 Uhr <br />
            DI, 15. September 2026 | 13.30 Uhr bis 15.30 Uhr
        </p>
        <p>
            8 Personen | 2 Stunden Fr. 75.— <br />
            Appenzell am Bahnhof
        </p>`,
    image: "/assets/images/FC27B7DF.jpg",
  },
  {
    uebertitel: "",
    titel: "Apéromalen",
    lead: ``,
    beschreibung: `
        <p>Ein grosses Blatt. Farben. Frische Blumen auf dem Tisch. Und ein Abend, der anders beginnt.</p>

        <p>Zwischen Gesprächen, Farben und Strichen wächst ein gemeinsames Bild. Mal entsteht etwas im Austausch, mal ganz still. Jede:r bringt ein, was gerade da ist.</p>

        <p>Mit Apérogetränk und etwas zum Knabbern.</p>
    `,
    sidebar: `
        <p>
            <strong>Kursdatum & Ort</strong><br />
            MO, 17. August 2026 | 17 Uhr bis 19 Uhr <br />
            DI, 15. September 2026 | 17 Uhr bis 19 Uhr
        </p>
        <p>
            8 Personen | 2 Stunden | Fr. 80.— <br />
            Appenzell am Bahnhof
        </p>`,
    image: "/assets/images/06CF5E6D.jpg",
  },
  {
    uebertitel: "",
    titel: "Farben in der Natur",
    lead: ``,
    beschreibung: `
        <p>Farben prägen unsere Wahrnehmung und bestimmen, wie wir die Welt erleben. Doch vieles entzieht sich dem schnellen Blick.</p>

        <p>An diesem Tag richten wir unsere Aufmerksamkeit auf Farben, Kontraste und Übergänge in der Natur. Mit verschiedenen Malmedien nähern wir uns dem, was wir sehen, vergleichen Farbtöne und halten Beobachtungen auf Papier fest. Drei kurze Inputs begleiten den Tag und eröffnen unterschiedliche Zugänge zum Wahrnehmen und Gestalten</p>

        <p>Nicht die naturgetreue Abbildung steht im Vordergrund, sondern die Auseinandersetzung zwischen Farbe und bewusster Wahrnehmung.</p>
    `,
    sidebar: `
        <p>
            <strong>Kursdatum & Ort</strong><br />
            9 .30 Uhr – 16 Uhr | Fr. 240.-- | Raum Appenzell <br />
            Die Mittagspause gestalten die Teilnehmenden individuell. 
        </p>
        <p>
            DI, 18. August 2026 <br />
            SA, 5. September 2026
        </p>`,
    image: "/assets/images/8C6B459A.jpg",
  },
  {
    uebertitel: "Kurs 3 Stunden",
    titel: "Mehr Verbundenheit und Vertrauen in der Natur erleben durch Pflanzenbetrachtung",
    lead: `Möchtest du dich tiefer mit der Natur verbinden?`,
    beschreibung: `Durch das eingehende Betrachten einer Pflanze, ist es möglich, sich mit ihrem Wesen, ihren Kräften zu verbinden und diese spüren. Dadurch können in uns selbst neue Qualitäten entwickelt werden, die uns in unserem Alltag unterstützen können. Wir setzen uns mit der Heilwirkung der Pflanze auseinander, verlassen aber diesen Wissensbereich bewusst, um uns mit unserer Wahrnehmung der Pflanze näher zu kommen.`,
    sidebar: `
        <p>
            <strong>Kursdatum & Ort</strong><br />
            Daten für 2026 folgen
        </p>
        <p>
            <strong>Kurskosten</strong><br />
            auf Anfrage
        </p>
        <p>
          <strong>Mitbringen</strong> <br>
          Persönliche Schreib-, Zeichnungs- und Malutensilien <br>
          Notizheft 
        </p>
        <p>
          <strong>Je nach Wetter</strong> <br>
          Wetterfeste Kleidung <br>
          Sonnenschutz
        </p>
        <p>
            <strong>Leitung</strong><br />
            Evelyn Krapf-Schibli <br> 
            Heilpädagogin MA <br>
            Psychosoziale Beratung MSc <br>
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie <br>
            Feldbotanikzertifikat 400 <br>
            Phytotherapie Ausbildung <br>
            Sortenerhalterin Pro Specie Rara <br>
            Mitglied Bioterra
        </p>`,
    image: "/assets/images/9726EAF5.jpg",
  },
  {
    uebertitel: "Führung 2 Stunden",
    titel: "Gartenführung",
    lead: `Unser vielfältiger und biologisch bewirtschafteter Garten bietet verschiedensten Insekten und weiteren Tieren einen gut strukturierten Lebensraum.`,
    beschreibung: `<p>Einheimische ein- bzw. mehrjährige Pflanzen und Wildobstgehölze sind Nahrungsquellen für Raupen, Schmetterlinge und Vögel.  Asthaufen und Totholz beherbergen Nagetiere und Wildbienen.</p>
                   <p>Im Garten duften unzählige Pflanzen wundervoll und einige davon schmecken ungeahnt gut. Eine grosse Anzahl sind auch für Menschen essbar oder unterstützen sie in ihrer Gesundheit. Gewisse Pflanzen blicken auf eine lange Nutzungstradition zurück, darunter bekanntere Namen wie der Apfel Goldparmäne oder die Bohne Neckarkönigin, andere nur weniger geläufig in der Nutzung wie der Färbemeister oder die Brennessel.</p>
                   <p>Komm mit auf einen Streifzug durch unseren Garten und erfahre Interessantes zu den Themen Staudenpflege, alte Sorten erhalten, aber auch zur Symbolik, zur Heilwirkung und zur Nutzung bzw. Anwendung.</p>`,
    sidebar: `
        <p>
            <strong>Datum & Ort</strong><br />
            Daten für 2026 folgen
        </p>
        <p>
            <strong>Kurskosten</strong><br />
            auf Anfrage
        </p>
        <p>
          <strong>Anmeldung</strong> <br>
           <a href="mailto:info@strich.sg">info@strich.sg</a>
        </p>
        <p>
            <strong>Leitung</strong><br />
            Evelyn Krapf-Schibli <br>
            Heilpädagogin MA <br>
            Psychosoziale Beratung MSc <br>
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie <br>
            Feldbotanikzertifikat 400 <br>
            Phytotherapie Ausbildung <br>
            Sortenerhalterin Pro Specie Rara <br>
            Mitglied Bioterra
        </p>`,
    image: "/assets/images/FC27B7DF.jpg",
  },
  {
    uebertitel: "Führung 2 Stunden",
    titel: "Gartenführung Heilpflanzen",
    lead: `Möchtest du mehr über Heilpflanzen, deren Wirkstoffe und deren Geschichte erfahren?`,
    beschreibung: `An dieser Führung erzähle ich, was alles in Pflanzen steckt und wie diese für unsere Gesundheit eingesetzt werden können. Bei gewissen Pflanzen ist jedoch Vorsicht geboten, weil sie Stoffe enthalten, die in gewissen Dosen schädlich wirken – die Dosis macht das Gift. Auf einem Streifzug durch unseren Garten vernimmst du Interessantes zur Symbolik, zur Nutzung und wie Pflanzen zubereitet werden können.`,
    sidebar: `
        <p>
            <strong>Datum & Ort</strong><br />
            Daten für 2026 folgen
        </p>
        <p>
            <strong>Kurskosten</strong><br />
            auf Anfrage
        </p>
        <p>
          <strong>Anmeldung</strong> <br>
           <a href="mailto:info@strich.sg">info@strich.sg</a>
        </p>`,
    image: "/assets/images/06CF5E6D.jpg",
  },
  {
    uebertitel: "Workshop 2 Tage",
    titel: "Regeneration in der Natur",
    lead: `Die Natur bietet Raum für Erleben und Erfahren, für Regeneration und Ressoucenstärkung. Die Basis des Kurses bilden ein vertieftes Wahrnehmen der Umgebung, ein lebendiges Annähern und in Beziehungtreten mit der Umwelt. Die bewusste Präsenz in der Gegenwart unterstützt innere Ruhe und Wohlbefinden zu empfinden und daraus Kraft zu entwickeln - gerade, wenn Menschen durch Stress belastet sind oder sich in widrigen Lebensumständen befinden. Angeregt werden ein Zugang zum Lebendigen, die Regeneration des Aufmerksamkeits- und Konzentrationsvermögens und die Unterstützung des Wohlbefindens.`,
    beschreibung: `In diesem Kurs erfährst du, wie in der Natur Kraft für den Alltag gefunden und wie diese Momente bewahrt werden können, um diese später in herausfordernden Situationen reaktivieren zu können. Menschen wachsen eingebettet in einer (mehr oder weniger) natürlichen Umwelt bzw. in Ökologien auf, diese Erfahrungen sind im Körper und im Gedächtnis gespeichert und beeinflussen die Biographie. <br /><br />

    Wir sind zwei Tage in einem Wechselspiel zwischen Wahrnehmung, Bewegung und Sein unterwegs. Im Zentrum steht das Ausprobieren kunsttherapeutischer Interventionen, das Erfahren und Reflektieren ihrer Wirkweisen und die Entwicklung von Anwendungsideen. Das Gestalten als kreativer Ausdruck und der Austausch in der Gruppe unterstützen den Selbsterfahrungsprozess und den Transfer in die Praxis.<br /><br />
    
    Die Auseinandersetzung mit der Natur findet über mal- und gestaltungstherapeutische Methoden, über Achtsamkeits- und Imaginationsübungen statt.`,
    sidebar: `
        <p>
            <strong>Kursziele</strong><br />
            Die Teilnehmenden<br />
            <ul style="list-style-position: inside; list-style-type: circle">
                <li>entdecken ökologische Einflüsse auf die eigene Biographie</li>
                <li>entwickeln ein Verständnis für die Bedeutung von kreativen Naturinterventionen in persönlichen Krisen</li>
                <li>erproben und erfahren kunsttherapeutische Interventionen und Übungen in der Natur und reflektieren den Transfer in die eigene berufliche Praxis</li>
            </ul>
        </p>
        <p>
            <strong>Kursdaten</strong><br />
            Daten für 2026 folgen<br />
        </p>
        <p>
            <strong>Kosten</strong><br />
            auf Anfrage
        </p>
        <p>
            <strong>Leitung</strong><br />
            Strichpunkt | Evelyn Krapf-Schibli<br />
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie<br />
            Psychosoziale Beratung MSc<br />
            Heilpädagogik MAS<br />
            Lehrerin für Textiles Werken
        </p>
        <p>
        <strong>Zielgruppe</strong><br />
        Fachpersonen aus der Kunsttherapie und dem psychosozialen Bereich, die den Aspekt Natur mit kreativen Mitteln in ihre Beratung und Therapie einbringen möchten.<br />
        Die Weiterbildung wird vom EMR für Weiterbildung im Umfang von 12 Stunden anerkannt.
        </p>`,
    image: "/assets/images/8C6B459A.jpg",
  },
  {
    uebertitel: "Workshop 3 Tage",
    titel: "Regeneration in der Natur",
    lead: `Die Natur bietet Raum für Erleben und Erfahren, für Entspannung, Regeneration
        und Ressourcenstärkung. Die Basis des Kurses bilden ein vertieftes Wahrnehmen
        der Umgebung, ein lebendiges Annähern und in Beziehungtreten mit der Umwelt. 
        Die bewusste Präsenz in der Gegenwart, unterstützt innere Ruhe und Wohlbefinden zu empfinden und daraus Kraft zu entwickeln. Gerade, wenn du durch Stress belastet bist oder dich in widrigen Lebensumständen befindest. Angeregt werden ein Zugang zum Lebendigen, die Regeneration von Aufmerksamkeits- und Konzentrationsvermögen und das Wohlbefinden.`,
    beschreibung: `<strong>Das Ansprechen aller Sinne durch die Natur, hilft Stress zu reduzieren und unterstützt Entspannung und Erholung. </strong>
        <br /><br />
        In diesem Kurs erfährst du, wie du in der Natur Kraft für deinen Alltag findest und wie du dir diese Momente bewahren kannst, damit sie später in herausfordernden Situationen zur Verfügung stehen.  
        <br /><br />
        Wir bewegen uns zwei Tage in einem Wechselspiel zwischen Wahrnehmung, dem Gestalten als Ausdruck und dem Austausch in einer kleinen Gruppe in der Natur.
        <br /><br />
        Die Auseinandersetzung mit einzelnen Pflanzen und der Natur findet über mal- und
        gestaltungstherapeutische Methoden, über imaginative Übungen und
        Achtsamkeitsanleitungen statt.  
        `,
    sidebar: `
        <p>
            <strong>Kursdaten</strong><br />
            Daten für 2026 folgen<br />
        </p>
        <p>
            <strong>Kosten</strong><br />
            auf Anfrage
        </p>
        <p>
            <strong>Leitung</strong><br />
            strichpunkt | Evelyn Krapf-Schibli<br />
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie<br />
			Psychosoziale Beratung MSc<br />
            Heilpädagogik MAS<br />
            Lehrerin für Textiles Werken
        </p>
        <p>
        <strong>Voraussetzungen</strong><br />
        keine
        </p>`,
    image: "/assets/images/A861EC27.jpg",
  },
  {
    uebertitel: "Workshop 2 Tage",
    titel: "Pflanzendruckverfahren",
    lead: `Es gibt unterschiedliche manuelle Drucktechniken, die geeignet sind, um Pflanzen abzubilden. Einerseits mit aufgetragener Farbe, andererseits mit Pflanzenkontaktdruck, wobei die Farbe von der Pflanze selber abgegeben wird.`,
    beschreibung: `Mit allen im Kurs gezeigten Techniken entstehen interessante Druckergebnisse; der Abdruck auf dem Papier bringt Überraschungen und spannende Effekte. Bei einigen lassen sich weitere Schichten auftragen, die eher transparent oder dann deckend sind, wodurch einzelne Stellen zurücktreten oder stärker betont werden. Durch die Weiterbearbeitung mit Filz-/Farbstiften, Gouache etc. lassen sich Akzente setzen. 
        <br /><br />
        In diesem Workshop lernt ihr die Grundlagen unterschiedlicher Drucktechniken kennen und anwenden. Gezeigt werden verschiedene Techniken, wobei ihr selber entscheidet, wo ihr euch vertiefen möchtet. Es entstehen individuelle Bilder in kleinen Formaten. 
        <br /><br />
        Blätter und Blüten sammeln wir während des Workshops auf einem Spaziergang in der Umgebung.
        `,
    sidebar: `
        <p>
            <strong>Kursdaten</strong><br />
            Daten für 2026 folgen<br />
        </p>
        <p>
            <strong>Kosten</strong><br />
            auf Anfrage
        </p>
        <p>
            <strong>Leitung</strong><br />
            strichpunkt | Evelyn Krapf-Schibli<br />
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie<br />
			Psychosoziale Beratung MSc<br />
            Heilpädagogik MAS<br />
            Lehrerin für Textiles Werken
        </p>
        <p>
        <strong>Voraussetzungen</strong><br />
        keine
        </p>`,
    image: "/assets/images/525586A6.jpg",
  },
  {
    uebertitel: "Wanderung",
    titel: "Wildpflanzen & Kräuter",
    lead: `Wanderung über das Hochmoor Appenzell`,
    beschreibung: `Auf unserem Weg werden wir verschiedene Wildpflanzen im Spätsommer ansehen und deren Merkmale kennenlernen. Dazu gibt es Interessantes zur Verwendung in früheren Zeiten und in der Gegenwart zu hören und welche Wirkstoffe in den Pflanzen stecken.`,
    sidebar: `
        <p>
            <strong>Kursdatum</strong><br />
            Daten für 2026 folgen
        </p>
        <p>
            <strong>Kosten</strong><br />
            auf Anfrage
        </p>
        <p>
            <strong>Leitung</strong><br />
            Evelyn Krapf-Schibli <br>
            Heilpädagogin MA <br>
            Psychosoziale Beratung MSc 
            Kunsttherapeutin iac Fachrichtung Mal- und Gestaltungstherapie <br>
            Feldbotanikzertifikat 400<br>
            zur Zeit in Ausbildung Phytotherapie <br>
            Sortenerhalterin Pro Specie Rara <br>
            Mitglied Bioterra
        </p>`,
    image: "/assets/images/2BAAEB34.jpg",
  },
]
